import React, { useContext, useMemo } from "react";
import { Outlet, useLocation } from "react-router-dom";
import ProtectedRoute from "../../utils/ProtectedRoute";
import Sidebar from "./Sidebar";
import LayoutContentContainer from "./LayoutContentContainer";
import ReportSidebar from "../../pages/Reports/Stepper/ReportSidebar";
import { AuthContext } from "../../contexts/AuthContext";
import PLATFORM_TYPES_ENUM from "../../lib/enums/platformTypes";
import {
  DASHBOARD_SIDEBAR_LINKS,
  DASHBOARD_SIDEBAR_CLIENT_LINKS,
  DASHBOARD_SIDEBAR_CONTRACTOR_LINKS,
} from "../../lib/constants/navigation";

const REPORT_PATHS = new Set([
  "/dashboard/reports/building-overview",
  "/dashboard/reports/financial-overview",
  "/dashboard/reports/information",
  "/dashboard/reports/maintenance",
]);

const NAV_BY_PLATFORM = {
  [PLATFORM_TYPES_ENUM.ADMIN]: DASHBOARD_SIDEBAR_LINKS,
  [PLATFORM_TYPES_ENUM.DELIVERY]: DASHBOARD_SIDEBAR_LINKS,
  [PLATFORM_TYPES_ENUM.CLIENT]: DASHBOARD_SIDEBAR_CLIENT_LINKS,
  [PLATFORM_TYPES_ENUM.CONTRACTOR]: DASHBOARD_SIDEBAR_CONTRACTOR_LINKS,
};

const RoleBasedLayout = () => {
  const location = useLocation();
  const { user } = useContext(AuthContext);

  const navLinks = useMemo(() => {
    return NAV_BY_PLATFORM[user?.platform_type];
  }, [user?.platform_type]);

  const isReportRoute =
    REPORT_PATHS.has(location.pathname) ||
    location.pathname.startsWith("/dashboard/reports/building-overview/element/");

  return (
    <ProtectedRoute>
      <div className="h-screen w-screen overflow-hidden flex flex-row">
        {isReportRoute ? <ReportSidebar /> : <Sidebar navigation={navLinks} />}
        <LayoutContentContainer>
          <Outlet />
        </LayoutContentContainer>
      </div>
    </ProtectedRoute>
  );
};

export default RoleBasedLayout;
